import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { StateManagementService } from "../../../providers/state-management/state-management.service";

@Component({
  selector: "painad-tool",
  templateUrl: "painad-tool.html",
})
export class PainadToolComponent implements OnInit {
  @Output() onValueUpdate: EventEmitter<any> = new EventEmitter();
  @Input() readonly: boolean = false;
  formGroup: FormGroup;

  breathingConfig = {};
  vocalizationConfig = {};
  facialConfig = {};
  bodyConfig = {};
  consolabilityConfig = {};

  constructor(
    public formBuilder: FormBuilder,
    public stateData: StateManagementService
  ) {
    this.formGroup = this.formBuilder.group({});
    this.formGroup.addControl(
      "painAdBreathing",
      this.formBuilder.control(undefined)
    );
    this.formGroup.addControl(
      "painAdVocalization",
      this.formBuilder.control(undefined)
    );
    this.formGroup.addControl(
      "painAdFacial",
      this.formBuilder.control(undefined)
    );
    this.formGroup.addControl(
      "painAdBody",
      this.formBuilder.control(undefined)
    );
    this.formGroup.addControl(
      "painAdConsolability",
      this.formBuilder.control(undefined)
    );

    this.formGroup.valueChanges.subscribe((data) => {
      let severity = 0;
      let allNull = true;
      let cuurentValue: boolean = false;
      for (let field of Object.keys(data)) {
        severity += data[field] * 1;
        if (data[field] !== null) {
          if (data[field] > 0) cuurentValue = true;
          allNull = false;
        }
      }
      if (cuurentValue == true) this.stateData.setMyData(1);
      else this.stateData.setMyData(0);
      this.onValueUpdate.emit({
        values: data,
        severity: allNull ? null : severity,
      });
    });
  }

  ngOnInit(): void {
    let options = ["0", "1", "2"];

    this.breathingConfig["id"] = "painAdBreathing";
    this.breathingConfig["componentId"] = "painAdBreathing";
    this.breathingConfig["readonly"] = this.readonly;
    this.breathingConfig["options"] = options;
    this.breathingConfig["descriptions"] = {
      "0": "painAd0Breathing",
      "1": "painAd1Breathing",
      "2": "painAd2Breathing",
    };

    this.vocalizationConfig["id"] = "painAdVocalization";
    this.vocalizationConfig["componentId"] = "painAdVocalization";
    this.vocalizationConfig["readonly"] = this.readonly;
    this.vocalizationConfig["options"] = options;
    this.vocalizationConfig["descriptions"] = {
      "0": "painAd0Vocalization",
      "1": "painAd1Vocalization",
      "2": "painAd2Vocalization",
    };

    this.facialConfig["id"] = "painAdFacial";
    this.facialConfig["componentId"] = "painAdFacial";
    this.facialConfig["readonly"] = this.readonly;
    this.facialConfig["options"] = options;
    this.facialConfig["descriptions"] = {
      "0": "painAd0Facial",
      "1": "painAd1Facial",
      "2": "painAd2Facial",
    };

    this.bodyConfig["id"] = "painAdBody";
    this.bodyConfig["componentId"] = "painAdBody";
    this.bodyConfig["readonly"] = this.readonly;
    this.bodyConfig["options"] = options;
    this.bodyConfig["descriptions"] = {
      "0": "painAd0Body",
      "1": "painAd1Body",
      "2": "painAd2Body",
    };

    this.consolabilityConfig["id"] = "painAdConsolability";
    this.consolabilityConfig["componentId"] = "painAdConsolability";
    this.consolabilityConfig["readonly"] = this.readonly;
    this.consolabilityConfig["options"] = options;
    this.consolabilityConfig["descriptions"] = {
      "0": "painAd0Consolability",
      "1": "painAd1Consolability",
      "2": "painAd2Consolability",
    };
  }

  @Input() set existingData(data: object) {
    if (data && data["tool"] === "painAD" && data["values"]) {
      this.formGroup.setValue(data["values"]);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/tools/painad-tool/painad-tool.ts